import { setMinTravelledDistance } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import NumberFilter from './NumberFilter';
import { useAppSelector } from '@customer/store/hooks';
import { MeasurementUnit } from '@customer/store/apis/authApi';

export const MinTravelledDistanceFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicInputElement>) => {
  const { t } = useTranslation();
  const units = useAppSelector(state => state.auth.units);

  return (
    <NumberFilter
      filterName="minTravelledDistance"
      label={
        label ??
        t('DistanceGreaterThan', {
          unit: t(units === MeasurementUnit.Metric ? 'unit.metre_other' : 'unit.feet_other'),
        })
      }
      tooltipLabel={t('Distance travelled')}
      elementRef={elementRef}
      action={setMinTravelledDistance}
    />
  );
};

export default MinTravelledDistanceFilter;
